import type { IconProps as Props } from './types';

export const IconBin = ({
  className,
  width = '20px',
  height = '20px',
  color = 'currentColor',
  ...rest
}: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      color={color}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 20 20"
      fill="none"
      {...rest}
    >
      <path
        id="Path"
        d="M11.6606 8.15406L11.4509 13.6924M8.54909 13.6924L8.33939 8.15406M14.3806 6.17872C14.5879 6.21072 14.7939 6.24457 15 6.28088M14.3806 6.17872L13.7333 14.7219C13.7069 15.0697 13.5522 15.3946 13.3 15.6315C13.0479 15.8685 12.7169 16.0001 12.3733 16H7.62667C7.28309 16.0001 6.95214 15.8685 6.69999 15.6315C6.44784 15.3946 6.29308 15.0697 6.26667 14.7219L5.61939 6.17872M14.3806 6.17872C13.6811 6.07135 12.978 5.98987 12.2727 5.93442M5.61939 6.17872C5.41212 6.21011 5.20606 6.24395 5 6.28026M5.61939 6.17872C6.31887 6.07135 7.02196 5.98987 7.72727 5.93442M12.2727 5.93442V5.37075C12.2727 4.64461 11.7212 4.03909 11.0061 4.01632C10.3355 3.99456 9.66448 3.99456 8.99394 4.01632C8.27879 4.03909 7.72727 4.64523 7.72727 5.37075V5.93442M12.2727 5.93442C10.7598 5.8157 9.24017 5.8157 7.72727 5.93442"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
